export default "__VITE_ASSET__BxRQxh4k__"